var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57425 17.9059C8.74649 17.9862 8.93793 18.016 9.12641 17.9919C9.31489 17.9678 9.49269 17.8909 9.63925 17.7699L15.6392 12.7699C15.7521 12.6761 15.843 12.5586 15.9053 12.4256C15.9677 12.2927 16 12.1477 16 12.0009C16 11.8541 15.9677 11.7091 15.9053 11.5762C15.843 11.4433 15.7521 11.3258 15.6392 11.2319L9.63925 6.23194C9.45823 6.0846 9.23165 6.00471 8.99825 6.00594C8.85162 6.00579 8.70679 6.03824 8.57425 6.10094C8.40219 6.18149 8.25664 6.30939 8.15463 6.46967C8.05262 6.62994 7.99838 6.81596 7.99825 7.00594L7.99825 17.0059C7.99932 17.1951 8.05401 17.38 8.15596 17.5393C8.25792 17.6986 8.40296 17.8258 8.57425 17.9059ZM9.99825 9.14094L13.4362 12.0059L9.99825 14.8709L9.99825 9.14094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99825 9.14094L13.4362 12.0059L9.99825 14.8709L9.99825 9.14094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d558213d562e8ce5aa88a68f100e6834.svg";
export { ForwardRef as ReactComponent };